import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { debounceTime, mergeMap } from 'rxjs/operators';

import { localizeNumber } from 'common/helpers';
import { notify } from 'common/hooks/useNotification';
import svgIcons from 'common/svgIcons';
import { CommonEpic } from 'common/types';

// import { actionLoadingGetTransactions } from 'views/wallet-new/redux/actions';
import { socketActionTypes } from 'blocks/SocketProvider/redux';

export const balanceTransactionsNotification: CommonEpic<null> = (action$) =>
  action$.pipe(
    ofType(socketActionTypes.SIGNALR_WALLET_BALANCE_TRANSACTION_EVENT),
    debounceTime(1000),
    mergeMap(({ payload }) => {
      notify({
        toastId: 'wallet-balance-updated-notification',
        icon: payload.status === 'Failed' ? svgIcons.Error() : undefined,
        titleFn: (translate) => {
          let actionText = '';
          switch (payload.action) {
            case 'Withdrawal':
              actionText = translate('mobile:notifications:transaction-event:action:withdrawal');
              break;
            case 'WithdrawalRequest':
              actionText = translate('mobile:notifications:transaction-event:action:withdrawalrequest');
              break;
            case 'Deposit':
            default:
              actionText = translate('mobile:notifications:transaction-event:action:deposit');
              break;
          }

          const statusText = translate(
            payload.status === 'Completed'
              ? 'mobile:notifications:transaction-event:status:successful'
              : 'mobile:notifications:transaction-event:status:failed',
          );

          return `${localizeNumber(payload.amount)} ${payload.currency ?? ''} ${actionText} ${statusText}`;
        },
      });
      // return of(actionLoadingGetTransactions());
      return EMPTY;
    }),
  );
